App.directive('textArea', ['$window', 'Config', function ($window, Config) {
    return {
    	restrict: 'AEC',
        scope: {
            form: '=',
            name: '@',
            placeholder: '@',
            notBorder: '=',
            notBg: '=',
            label: '@',
            rows: '@',
            model: '=',
            required: '@',
            // @TODO: <HEALTH2019>
            maxlength: '@',
            // @TODO: </HEALTH2019>
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/text-area.html'
    };
}]);
